export default __webpack_public_path__ + "static/media/thinkpad-logo.f90802ba.svg";